import React from 'react';
import { AppMenuItem, Card, CloseButton, HR, Overlay } from './Menu.styles';
import { color } from '@nuvolo/nuux-theme/utils';
import FAIcon from '#/common/components/FAIcon';
import useApplicationPickerItems from '#/app/hooks/useApplicationPickerItems';
import If from '#/common/components/If';

interface ApplicationPickerCardProps {
  onClose: () => void;
  opened?: boolean;
  variant?: 'desktop' | 'mobile';
}

const ApplicationPickerCard: React.FC<ApplicationPickerCardProps> = ({
  onClose,
  opened = false,
  variant = 'desktop',
}) => {
  const appItems = useApplicationPickerItems();

  const handlePickerItemClick = (url: string) => {
    onClose();
    if (url) {
      // This will reload the page
      window.location.href = url;
    }
  };

  return (
    <If condition={opened}>
      <Overlay onClick={onClose} />
      <Card variant={variant} w={320} type="appPicker">
        {variant === 'mobile' && (
          <CloseButton onClick={() => onClose()}>
            <FAIcon icon="xmark" color={color('secondary', 'dark2')} />
          </CloseButton>
        )}
        {appItems
          .filter((item, i, items) => {
            if (item === 'separator') {
              return items[i + 1] !== 'separator' && i < items.length - 1;
            }
            return true;
          })
          .map((item) =>
            item === 'separator' ? (
              <HR />
            ) : (
              <AppMenuItem key={item.id} size="md" onClick={() => handlePickerItemClick(item.url)}>
                <FAIcon icon={item.icon} color={color('custom', 'iconGray')} />
                <span className="item-text">{item.name}</span>
              </AppMenuItem>
            ),
          )}
      </Card>
    </If>
  );
};

export default ApplicationPickerCard;
